import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import useCheckAccess from '@jwp/ott-hooks-react/src/useCheckAccess';
import { modalURLFromLocation } from '@jwp/ott-ui-react/src/utils/location';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import ReactGA from 'react-ga4';
import { useGADeviceType } from '@jwp/ott-common/src/utils/GADeviceType';

import Spinner from '../Spinner/Spinner';
import { useAriaAnnouncer } from '../../containers/AnnouncementProvider/AnnoucementProvider';
import useQueryParam from '../../hooks/useQueryParam';

import styles from './WaitingForPayment.module.scss';
import { sendGAEvent } from '@jwp/ott-hooks-react/src/useAnalytics';

const WaitingForPayment = () => {
  const { t } = useTranslation('account');
  const offerId = useQueryParam('offerId') || undefined;
  const location = useLocation();
  const navigate = useNavigate();
  const announce = useAriaAnnouncer();
  const { intervalCheckAccess, errorMessage } = useCheckAccess();
  const { isGoogleAnalytics, isAnalyticsEnable, subscription_type } = useAppConfig();
  const user = useAccountStore((state) => state.user);
  const isLoggedIn = !!user;
  const userId = isLoggedIn ? user.id : 'Guest user';
  const deviceType = true ? useGADeviceType() : null;
  const mediaOffersList = useAccountStore(({ mediaOffer }) => mediaOffer);
  const successHandledRef = useRef(false);
  // const resolvedOfferIds = mediaOffersList?.map(o => o.offerId) ?? undefined;

  useEffect(() => {
    intervalCheckAccess({
      interval: 3000,
      iterations: 5,
      offerId,
      callback: ({ hasAccess, offerId }) => {
        if (isAnalyticsEnable && hasAccess) {
          sendGAEvent('access_granted', {
            asset_id: offerId,
            access_type: 'N/A',
            provider: subscription_type,
            userid_no: userId,
            device_type: deviceType,
          });
        }
        if (!hasAccess || successHandledRef.current) return;

        successHandledRef.current = true; // to avoid multiple render of welcome popup
        announce(t('checkout.payment_success'), 'success');
        // navigate(modalURLFromLocation(location, 'welcome'));
        navigate(modalURLFromLocation(location, 'payment-success'));
      },
    });
    //eslint-disable-next-line
  }, []);
  return (
    <div className={styles.center}>
      {errorMessage ? (
        <h2>{errorMessage}</h2>
      ) : (
        <>
          <Spinner />
          <h2>{t('checkout.waiting_for_payment')}</h2>
        </>
      )}
    </div>
  );
};

export default WaitingForPayment;
